import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function AllowedFilesPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>
          Akceptowalne pliki | IKSEL Studio Reklamy - Reklama dla Twojej firmy
        </title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - Rodzaje akceptowalnych plików i wymagania dotyczące projektów graficznych. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="akceptowalne-pliki"
          title="Akceptowalne pliki"
          subtitle="Ogólne zasady przyjmowania plików do druku"
          html={`
            <h2>Formaty plik&oacute;w</h2>

            <h3>TIF - należy zachować odpowiednie parametry:</h3>
            
            <ul>
              <li>format 1:1,</li>
              <li>spady po 3 mm z każdej strony,</li>
              <li>rozdzielczość 350 dpi,</li>
              <li>tryb kolor&oacute;w CMYK, bez osadzonych dodatkowych profili (lub zadany profil &bdquo;Coated Fogra 39 (ISO 12647-2):2004)&ldquo;,</li>
              <li>bez warstw &ndash; spłaszczone,</li>
              <li>zalecana kompresja LZW lub spakowane ZIP,</li>
              <li>projekt wyśrodkowany na stronie,</li>
              <li>odległość obiekt&oacute;w graficznych i tekst&oacute;w od linii cięcia min 3 mm.(katalogi i teczki 5 mm)</li>
              <li>wszystkie bitmapy powinny być zapisane w trybie CMYK 8 bit na kanał. W przypadku 16 lub 32 bit&oacute;w mogą wystąpić błędy za kt&oacute;re Drukarnia IKSEL nie ponosi odpowiedzialności</li>
            </ul>
            
            <h3>JPG - należy zachować odpowiednie parametry</h3>
            
            <ul>
              <li>format 1:1,</li>
              <li>spady po 3 mm z każdej strony,</li>
              <li>rozdzielczość 350 dpi,</li>
              <li>tryb kolor&oacute;w CMYK, bez osadzonych dodatkowych profili (lub zadany profil &bdquo;Coated Fogra 39 (ISO 12647-2):2004)&ldquo;,</li>
              <li>projekt wyśrodkowany na stronie.</li>
              <li>odległość obiekt&oacute;w graficznych i tekst&oacute;w od linii cięcia min. 3 mm (katalogi i teczki zalecane 5 mm)</li>
              <li>wszystkie bitmapy powinny być zapisane w trybie CMYK 8 bit na kanał. W przypadku 16 lub 32 bit&oacute;w mogą wystąpić błędy za kt&oacute;re Drukarnia IKSEL nie ponosi odpowiedzialności</li>
            </ul>
            
            <h3>PDF - PrePress - zgodność: Acrobat 4 (PDF 1.3)</h3>
            
            <ul>
              <li>wszystkie fonty zamienione na krzywe,</li>
              <li>spady po 3 mm z każdej strony,</li>
              <li>jeśli w pracy znajdują się mapy bitowe, to powinny być one odpowiednio zapisane w skali 1:1,</li>
              <li>rozdzielczość 350 dpi (prace są naświetlane przy liniaturze 175 lpi),</li>
              <li>tryb kolor&oacute;w CMYK bez osadzonych dodatkowych profili (lub zadany profil &bdquo;Coated Fogra 39 (ISO 12647-2):2004)&ldquo;,</li>
              <li>projekt wyśrodkowany na stronie,</li>
              <li>odległość obiekt&oacute;w graficznych i tekst&oacute;w od linii cięcia min. 3 mm (katalogi i teczki zalecane 5 mm)</li>
              <li>wszystkie bitmapy umieszczone w PDF powinny być zapisane w trybie CMYK 8 bit na kanał. W przypadku 16 lub 32 bit&oacute;w mogą wystąpić błędy za kt&oacute;re Drukarnia IKSEL nie ponosi odpowiedzialności</li>
            </ul>
            
            <h3>CDR - pliki programu Corel Draw (do wersji X4)</h3>
            
            <ul>
              <li>prace lakierowane (pogląd pracy wraz z lakierem na osobnej stronie), 1:1,</li>
              <li>wykrojniki do danych prac (na pierwszej stronie wykrojnik nałożony na pracę na drugiej stronie pracę do druku bez wykrojnika) &ndash; linie cięcia oznaczamy na niebiesko linie falcu na czerwono , 1:1,</li>
              <li>fonty zamienione na krzywe,</li>
              <li>spady po 3 mm z każdej strony,</li>
              <li>wewnętrzne mapy bitowe o odpowiednich parametrach (1:1, 350dpi, CMYK),</li>
              <li>praca nie może zawierać żadnych dodatkowych kolor&oacute;w,</li>
              <li>projekt, wykrojnik i lakier wyśrodkowany na stronie,</li>
              <li>jeśli w pracy znajdują się mapy bitowe, to powinny być one odpowiednio zapisane w skali 1:1,</li>
              <li>rozdzielczość 350 dpi (prace są naświetlane przy liniaturze 175 lpi),</li>
              <li>tryb kolor&oacute;w CMYK bez osadzonych dodatkowych profili (lub zadany profil &bdquo;Coated Fogra 39 (ISO 12647-2):2004)&ldquo;,</li>
              <li>projekt wyśrodkowany na stronie,</li>
              <li>odległość obiekt&oacute;w graficznych i tekst&oacute;w od lini cięcia min. 3 mm (katalogi I teczki zalecane 5mm).</li>
              <li>wszystkie bitmapy umieszczone w CDR powinny być zapisane w trybie CMYK 8 bit na kanał. W przypadku 16 lub 32 bit&oacute;w mogą wystąpić błędy za kt&oacute;re Drukarnia IKSEL nie ponosi</li>
              <li>odpowiedzialności</li>
              <li>Orientacja pracu musi się zgadzać z ustawieniami orientacji arkusza. (Dla pracy poziomej, arkusz powinien być poziomy)</li>
            </ul>
            
            <h3>UWAGA!!!</h3>
            
            <p>Drukarnia IKSEL NIE PONOSI odpowiedzialności za prace przysłane w programie Corel Draw i pliki PDF publikowane z programu Corel Draw oraz wynikające z tego tytułu błędy. Uwaga wszystkie pliki w formacie CDR będą automatyczne konwertowane do formatu PDF z zamianą kolorystyki na CMYK z wyłączeniem papier&oacute;w firmowych zam&oacute;wionych w kolorystyce PANTONE lub HKS ) Drukarnia IKSEL NIE PONOSI odpowiedzialności za konwersję kolor&oacute;w z programu Corel Draw. Drukarnia IKSEL NIE PONOSI odpowiedzialności za prace, w kt&oacute;rych odległość od linii cięcia nie jest zgodna ze specyfikacją.</p>
            
            
            <p>WSZYSTKIE CZCIONKI MAJĄ BYĆ ZAMIENIONE NA KRZYWE.</p>
            
            
            <p>Drukarnia IKSEL NIE PONOSI odpowiedzialności za prace, w kt&oacute;rych czcionki nie zostały zamienione na krzywe.</p>
            
            
            <p>W przypadku plik&oacute;w PDF wyeksportowanych z programu Corel Draw, aby uniknąć błęd&oacute;w w wydruku należy zaznaczyć wszystkie zdjęcia i obiekty na pracy i połączyć je z tłem - przekształcić na mapę bitową.</p>
            
            
            <p>W związku z możliwością wystąpienia błęd&oacute;w przy generacji plik&oacute;w PDF w postaci WEKTOROWEJ a nie jako bitmapa z programu Adobe Photoshop, pliki wynikowe z programu Adobe Photoshop powinny być zapisywane jako TIFF bez warstw - spłaszczone. IKSEL NIE PONOSI odpowiedzialności za błędnie wygenerowane pliki PDF z programu Adobe Photoshop, oraz pliki błędnie wygenerowane przez programy Adobe Photoshop i Corel Draw przekonwertowane przez inne oprogramowanie np. Adobe Indesign.</p>
            
            <h3>Prawidłowo przygotowany PDF</h3>
            
            
            <p><strong>PDF-y &ndash; PrePress:</strong></p>
            
            <ul>
              <li>acrobat 4 wersja 1.3,</li>
              <li>zdjęcia 350dpi,</li>
              <li>wektory 2400 dpi,</li>
              <li>spady po 3 mm + linie cięcia,</li>
              <li>katalogi i broszury - strony w kolejności 1,2,3 ... itd. (żadnych składek),</li>
              <li>całość CMYK,</li>
              <li>dokładne opisy plik&oacute;w tj. Katalog_X_Srodki.pdf Katalog_X_Okładka.pdf, (gdzie x=nazwa),</li>
              <li>ulotki składane, przygotowane wg wzor&oacute;w dostępnych na naszej stronie,</li>
              <li>projekt wyśrodkowany na stronie.</li>
              <li>czcionki zamienione na krzywe</li>
            </ul>
            
            <h3>Układ graficzny</h3>
            
            <p><strong>Formaty:</strong>&nbsp;Do pracy kt&oacute;ra ma być mniejsza od wybranego formatu należy dołączyć plik tekstowy (.txt) spakowany razem z pracą, w pliku powinien znajdować się rozmiar do jakiego formatu ma być docięta praca (NIE DOCINAMY WIZYT&Oacute;WEK I DO FORMATU MNIEJSZEGO NIŻ A6 - 105mm na 148mm)</p>
            
            
            <p>Katalogi i broszurki należy przesyłać w formacie PDF strona po stronie (żadnych składek)</p>
            
            
            <p><strong>Każda strona powinna zawierać:</strong></p>
            
            <ul>
              <li>linie cięcia według formatu zgodnego z formatem publikacji;</li>
              <li>opis kolor&oacute;w dodatkowych jeżeli występują;</li>
              <li>opis numeru strony (katalogi, broszurki) w obszarze poza liniami cięcia jeśli dana praca nie posiada paginacji.</li>
              <li>Elementy drukowane na spad (naddatek) powinny wychodzić poza linie cięcia na minimum 3 mm (w przypadku oprawy zeszytowej zalecane to 5 mm).</li>
            </ul>
            
            <p>W przypadku reklam, ze względu na możliwość drukowania na stronach parzystych i nieparzystych spady powinny występować ze wszystkich stron. Jeżeli chcą Państwo wydruk 4/4 z takim samym zadrukiem dla obu stron, proszę przygotować plik z dwoma takimi samymi stronami lub wgrać dwa takie same pliki.</p>
            
            <p>Własne elementy tekstowe lub graficzne nie powinny znajdować się w odległości mniejszej niż 3 mm od linii cięcia (zalecane 5mm) powyżej 32 stron przy oprawie szytej 5mm (zalecane 8mm).</p>
            
            <p>Dla oprawy szytej należy uwzględnić zjawisko fizycznego zmniejszania się formatu strony do środka. Na życzenie Klienta, Drukarnia koryguje na etapie montażu położenie stron kompensując efekt grubości grzbietu. Korekta jest wyliczana wyłącznie w oparciu o gramaturę papieru. Opcja ta jest niemożliwa do wykonania w przypadku rozkład&oacute;wek.Powoduje to zabranie obrazu wzdłuż linii grzbietu, im pagina jest bliższa środka egzemplarza tym więcej. W takich przypadkach zakłada się automatycznie, że układ/projekt strony pozwala na tę operację.</p>
            
            <p>Lakier wybi&oacute;rczy powinien być przygotowany na osobnym arkuszu/stronie. Miejsca lakierowane powinny zostać wypełnione 100% apli składowych CMYK (zalecany czarny kolor).</p>
            
            
            <p><strong>Uwaga!</strong>&nbsp;Margines błędu przy cieciu, może wynosić maksymalnie 2mm! Należy zachować 1 cm odstępu od linii formatu dla istotnych element&oacute;w grafiki na stronie (zwłaszcza długich, r&oacute;wnoległych do krawędzi strony).</p>
            
            <p>W przypadku opraw klejonych, należy pamiętać, że 2 i 3 strona okładki oraz 1 i ostatnia strona wkładu będą miały zaklejone 6 mm od strony grzbietu poprzez klejenie boczne. Z tego względu minimalna odległość element&oacute;w graficznych i tekstowych powinna wynosić 10 mm. Wewnątrz publikacji powinno się także zachować odstęp mim 10 mm.</p>
            
            
            <p><strong>Informacje o kratkach w bloczkach:</strong></p>
            
            <ul>
              <li>Kratka bloczk&oacute;w w szarościach powinna mieć 0,2 mm - 20 % czarnego i 0,12 - 35% czarnego.</li>
              <li>Poniżej punkt rastrowy może zanikać i linie będą niepełne lub kratka bloczk&oacute;w czarny 100% linia może mieć szerokość minimum 0,05 mm.</li>
            </ul>
            
            <p>Efektywny format rozkład&oacute;wek w egzemplarzu przy oprawie klejonej jest mniejszy od nominalnego z powodu niepełnego otwarcia książki. Korekta (zdublowanie obrazu przy wewnętrznej krawędzi strony) powinna być uwzględniona w pliku. Drukarnia nie wprowadza korekty układu lub formatu strony.</p>
            
            <p>Znak wodny powinien być przygotowany z minimalnym nafarbieniem 8% dla koloru czarnego lub wszystkich kanał&oacute;w CMYK.</p>
            
            
            <p><strong>Uwaga!!</strong>&nbsp;obiekty 100% czarne zostają nadrukowane (overprinty), Drukarnia IKSEL NIE PONOSI odpowiedzialności za nadrukowania (overprinty) na innych kolorach zadanych w pracy.</p>
            
            <p>Prace obracane są automatycznie lewą/prawą stronę. Nie obracamy prac g&oacute;ra/d&oacute;ł.</p>
            
            
            <p>Drukarnia IKSEL nie ponosi odpowiedzialności za nieprawidłowo obracane strony Drukarnia IKSEL NIE PONOSI odpowiedzialności za zmiany kolorystyczne w pracach wynikające z konwersji profili niezgodnych ze specyfikacją do profilu Coated Fogra 39 (ISO 12647-2):2004.</p>
            `}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default AllowedFilesPage;
